// @flow
import * as React from "react";

import { useSelector, useDispatch } from "react-redux";

import { deletePushNotification } from "state/actions/pushNotifications";

import Banner from "./Banner";

import type { State as PushNotificationState } from "state/reducers/pushNotifications";
import type { PushNotification } from "push-notification";

type State = {
  pushNotifications: PushNotificationState,
};

function PushNotifications(): React.Node {
  const notifications = useSelector<State, PushNotification[]>((state) => state.pushNotifications);
  const dispatch = useDispatch();

  const handleDelete = (index: number) => {
    dispatch(deletePushNotification(index));
  };

  return notifications.map(({ id, title, message }, index) => (
    <Banner key={id} title={title} message={message} onDelete={() => handleDelete(index)} />
  ));
}

export default PushNotifications;
